(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  jQuery('.header__icon--menu').on('click', function () {
    jQuery('html').toggleClass('mobile-menu-active');
    console.log('Button Style Change event fired');
  });

  $find_model_steps =
    '<div class="find-model-steps"> <div class="row"> <div class="col-4"> <div class="image-box"> <img src="https://cdn.shopify.com/s/files/1/0647/6840/9822/files/01.png?v=1692107276" alt=""> </div> <div class="text-box"> <p> Go to <strong>Settings</strong> and select <strong>General</strong>. </p> </div> </div> <div class="col-4"> <div class="image-box"> <img src="https://cdn.shopify.com/s/files/1/0647/6840/9822/files/02.png?v=1692107276" alt=""> </div> <div class="text-box"> <p> Then tap on <strong>About</strong>. </p> </div> </div> <div class="col-4"> <div class="image-box"> <img src="https://cdn.shopify.com/s/files/1/0647/6840/9822/files/03.png?v=1692107276" alt=""> </div> <div class="text-box"> <p> Tap on the <strong>M model number</strong> to show the <strong>A model number</strong> </p> </div> </div> </div> </div>';
  const box = document.getElementById('_mpr-sn-lookup');
  const modelsteps = document.createElement('div');

  modelsteps.innerHTML = $find_model_steps;
  if (box) {
    box.appendChild(modelsteps);
    if (document.querySelector('body').classList.contains('product.ipad')) {
      holder = document.querySelector('div[data="Find your Model"] details');
      holder.appendChild(box);
    }
  }
  jQuery('.shop-by-device').click(function (e) {
    if (window.innerWidth > 989) {
      jQuery('html, body').animate(
        {
          scrollTop: jQuery('.header').offset().top,
        },
        1000
      );
      jQuery('body').addClass('shop-by-device-trigger');

      jQuery('#Details-HeaderMenu-2 .header__menu-item').trigger('click');
    } else {
      jQuery('.header__icon--menu').trigger('click');
      jQuery('#Details-menu-drawer-menu-item-2 > .menu-drawer__menu-item').trigger('click');
      jQuery('#Details-menu-drawer-submenu-1 .menu-drawer__menu-item').trigger('click');
    }
    e.preventDefault();
  });

  if (window.innerWidth > 989) {
    jQuery(document).mouseup(function (e) {
      if (jQuery('.shop-by-device-trigger').length > 0) {
        var container = jQuery('.shop-by-device-trigger #MegaMenu-Content-2');

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          jQuery('#Details-HeaderMenu-2 .header__menu-item').trigger('click');
          jQuery('body').removeClass('shop-by-device-trigger');
        }
      }
    });
  }

  setTimeout(() => {
    var el = document.querySelector('.caption a');
    if (el) {
      el.addEventListener('click', function (e) {
        const scrollTarget = document.querySelector('div[data="Find your Model"]');
        window.scrollTo(0, scrollTarget.offsetTop);

        document.querySelector('div[data="Find your Model"] details').setAttribute('open', '');

        e.preventDefault();
      });
    }
  }, 2000);

  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
    return false;
  };

  var $form = getUrlParameter('form');

  const style = document.createElement('style');
  style.type = 'text/css';
  if ($form == 'product-registration') {
    style.textContent =
      '#mpr-product-inputs form > .form-group {display: none} .mpr-input-label .mpr-custom-label { font-weight: initial !important; } #mpr-registered { display: none !important }';
  } else if ($form == 'make-a-warranty-claim_79') {
    style.textContent =
      '#mpr-registered { display: none !important } #mpr-app-content h1 { text-align: center !important }';
  } else {
    style.textContent =
      '.mpr-input-label .mpr-custom-label { font-weight: initial !important; } #mpr-registered > h1 {display:none !important} #mpr-root {max-width: 1500px !important;} .registered-products { display: block !important; margin-top: 100px  } #mpr-registered-product-registration>.button { display: none !important } #mpr-app-content h1 { text-align: center !important; } #mpr-form { display: none !important} ';
  }

  document.head.appendChild(style);

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
